import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { FlexCenterWrapper, Mr3, FlexCenterBetweenWrapper, Mr2 } from 'wrappers';
import { getInitials } from 'utils/getInitials';
import { Image, PriorityLabel, ProfileImage, Initials, SecondaryTextSm, Icon } from 'atoms';
import { colorShade } from 'utils';
import { PipeSvg } from 'components/icons'

const template = styled.div``;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: FlexCenterBetweenWrapper,
      name: 'TopSection',
      atoms: [
        {
          component: PriorityLabel,
          name: 'ParentCategory',
          displayValue: ({ order }) => order?.parent_category_name?.toUpperCase() ?? '',
          displayState: ({ }) => ({
            priority: {
              background: colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B'),
              textColor: window?.settings?.primary_color ?? '#1DBD6B',
            },
            height: '26px'
          }),
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'Images',
          atoms: [
            {
              component: wrap(Image, Mr2),
              name: 'PropertyIcon',
              renderIf: ({ propertyIcon }) => !!propertyIcon,
              displayValue: ({ propertyIcon }) => propertyIcon,
              displayState: ({ }) => ({ width: '23px', height: '23px' })
            },
            {
              component: wrap(SecondaryTextSm, Mr3),
              renderIf: ({ order, selectedTab }) => (selectedTab === 'recurring' && !!order?.unit) || !!order?.unit_number,
              name: 'UnitNumber',
              displayValue: ({ order, selectedTab }) => (selectedTab === 'recurring' ? order?.unit : order?.unit_number) ?? ''
            },
            {
              component: wrap(Icon, Mr3),
              name: 'Pipe',
              renderIf: ({ order }) => order?.tech_image || order?.tech_name || order?.vendor_url || order.vendor_name,
              displayValue: ({ }) => PipeSvg({ width: 3, height: 20, color: colorShade(0.7, window?.settings?.secondary_color ?? '#04333B') })
            },
            {
              component: ProfileImage,
              name: 'TechImage',
              renderIf: ({ order }) => order?.tech_image,
              displayValue: ({ order }) => order.tech_image,
              displayState: ({ }) => ({ size: '20' })
            },
            {
              component: Initials,
              name: 'TechInitials',
              renderIf: ({ order }) => !order?.tech_image && order?.tech_name,
              displayValue: ({ order }) => getInitials(order.tech_name),
              displayState: ({ }) => ({ size: '20' })
            },
            {
              component: ProfileImage,
              name: 'VendorImage',
              renderIf: ({ order }) => order.vendor_url,
              displayValue: ({ order }) => order.vendor_url,
              displayState: ({ }) => ({ size: '20' })
            },
            {
              component: Initials,
              name: 'VendorInitials',
              renderIf: ({ order }) => !order?.vendor_url && order?.vendor_name,
              displayValue: ({ order }) => getInitials(order.vendor_name),
              displayState: ({ }) => ({ size: '20' })
            },
          ]
        }],
    }]
})